<div [formGroup]="labelForm">
    <h3 class="mb-3">{{ 'instance-provisioning-label-form_label_header' | i18next }}</h3>
    <div class="row">
        <app-input-text class="col-12 col-md-6" [control]="labelForm.get('name')!" name="name"></app-input-text>
        <app-input-text class="col-12 col-md-6" [control]="labelForm.get('key')!" name="key"></app-input-text>
        <app-input-select class="col-12 col-md-6" [options]="uninstallOptions" [control]="labelForm.get('onUninstall')!" name="on_uninstall"></app-input-select>
        <app-input-select class="col-12 col-md-6" [options]="labelTypeOptions" [control]="labelForm.get('labelType')!" name="type"></app-input-select>
        <app-input-select class="col-12 col-md-6" [options]="labelVisibilityOptions" [control]="labelForm.get('visible')!" name="visible"></app-input-select>
    </div>
</div>